import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';

export interface IListItem {
    id: number;
    name: string;
}

export class SexesApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Sexes`;

    public static apiUrls = {
        getAll: `${SexesApi.baseApiUrl}`,
    };

    public static async getAll(): Promise<IListItem[]> {
        return this.sendApiRequest<IListItem[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getAll,
        });
    }
} 